module.exports = __webpack_public_path__ + "img/microphone.7cd0e5be.svg";